import type { CreateCustomerInput, CustomerBulkPatch, DeleteRecordsInput, UpdateCustomerInput } from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listCustomers() {
  return getDesktopApi().customers.listCustomers();
}

export async function getCustomerById(customerId: string) {
  return getDesktopApi().customers.getCustomerById(customerId);
}

export async function deleteCustomers(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().customers.deleteCustomers(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function listDeletedCustomers() {
  return getDesktopApi().customers.listDeletedCustomers();
}

export async function restoreCustomers(payload: DeleteRecordsInput) {
  return getDesktopApi().customers.restoreCustomers(payload);
}

export async function purgeCustomers(payload: DeleteRecordsInput) {
  return getDesktopApi().customers.purgeCustomers(payload);
}

export async function createCustomer(payload: CreateCustomerInput) {
  return getDesktopApi().customers.createCustomer(payload);
}

export async function updateCustomer(payload: UpdateCustomerInput) {
  const result = await getDesktopApi().customers.updateCustomer(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function applyBulkCustomerPatch(payload: CustomerBulkPatch) {
  const result = await getDesktopApi().customers.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}
